import './App.css';
import { useState, useRef, useEffect } from "react";
import { useSearchParams } from "react-router-dom";

const BASE = process.env.PUBLIC_URL;

const qrMap = {
  bpi:       { img: `${BASE}/qr/qr-bpi.png`,       number: "0649424272",     name: "Stephen Salamante", label: "BPI",       accent: "#d04141" },
  unionbank: { img: `${BASE}/qr/qr-unionbank.png`, number: "1098 9500 9110", name: "Stephen Salamante", label: "UnionBank", accent: "#ddb230" },
  maribank:  { img: `${BASE}/qr/qr-seabank.png`,   number: "12387270166",    name: "", label: "MariBank",  accent: "#d6803a" },
  gcash:     { img: `${BASE}/qr/qr-gcash.png`,     number: "09158631322",    name: "", label: "GCash",     accent: "#007dfe" },
  maya:      { img: `${BASE}/qr/qr-maya.png`,      number: "09158631322",    name: "", label: "Maya",      accent: "#5cb85c" },
};

Object.values(qrMap).forEach(({ img }) => {
  const el = new Image();
  el.src = img;
});

export default function App() {
  const [searchParams, setSearchParams] = useSearchParams();
  const initialTab = searchParams.get("tab");

  const [selected, setSelected] = useState(initialTab && qrMap[initialTab] ? initialTab : null);
  const [opacity, setOpacity]   = useState(1);
  const isTransitioning         = useRef(false);

  const current = selected ? qrMap[selected] : null;

  // Sync state → URL
  useEffect(() => {
    if (selected) {
      setSearchParams({ tab: selected }, { replace: true });
    } else {
      setSearchParams({}, { replace: true });
    }
  }, [selected, setSearchParams]);

  function handleSelect(key) {
    if (isTransitioning.current) return;
    isTransitioning.current = true;

    const next = selected === key ? null : key;

    setOpacity(0);
    setTimeout(() => {
      setSelected(next);
      setOpacity(1);
      isTransitioning.current = false;
    }, 150);
  }

  return (
    <>
      <div className="qr-root">
        <div className="qr-layout">

          <div className="qr-list">
            {Object.entries(qrMap).map(([key, val]) => (
              <button
                key={key}
                className={`qr-list-item${selected === key ? " qr-list-item--active" : ""}`}
                style={selected === key ? { backgroundColor: val.accent, borderColor: val.accent } : {}}
                onClick={() => handleSelect(key)}
              >
                {val.label}
              </button>
            ))}
          </div>

          <div
            className="qr-card"
            style={current ? { borderColor: current.accent } : {}}
          >
            <div className="qr-card-content" style={{ opacity }}>
              {current ? (
                <img
                  className="qr-card-img"
                  src={current.img}
                  alt={`${current.label} QR code`}
                />
              ) : (
                <div className="qr-card-placeholder">
                  <img src={`${BASE}/qr/placeholder.jpg`} alt="placeholder" />
                </div>
              )}
              <div className="qr-card-body">
                <code>
                  {current ? (
                    <>
                      {current.name && <>{current.name}<br /></>}
                      {current.number}
                    </>
                  ) : "welcome to stephen's qr payment portal"}
                </code>
              </div>
            </div>
          </div>

        </div>
      </div>
    </>
  );
}